const lbToKg = (lb: number): number => {
  return Math.round(lb * 0.453592);
};

export default lbToKg;
